import { Component, OnInit } from "@angular/core";

@Component({
	selector: "caass-parent-portal-by-parent-mode",
	templateUrl: "./parent-portal-by-parent-mode.component.html",
	styleUrls: ["./parent-portal-by-parent-mode.component.css"],
})
export class ParentPortalByParentModeComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {}

	///////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////

	Name: string = "";
	Email: string = "";

	///////////////////////////////////////////////////
}
